export class Logger {

  static debug(message: string | Record<string, unknown>) {
    if (process.env.NODE_ENV !== "production") {
      console.log(message);
    }
  }

}